module.exports = __webpack_public_path__ + "images/drone-shooting-integration-c6cc4822e62eb77cecbff4a847d02d89.jpg";